import GroupsIcon from '@mui/icons-material/Groups'
export default {
  name: 'user-groups',
  recordRepresentation: 'name',
  icon: GroupsIcon,
  options: {
    defaultSort: { field: 'name', order: 'ASC' },
    badge: true,
  },
}
